// en.js
const vi = {
  common: {
    pageTitle: "Quantera Joint Stock Company",
  },
  header: {
    nav: {
      about: "Introduction",
      solutions: "Solutions",
      apps: "Applications",
      ecosystem: "Ecosystem",
      partners: "Partners",
      blogs: "Blog",
      contact: "Contact",
      trynow: "Sign up now",
    },
    hero: {
      brand: "QUANTERA",
      headline:
        "PIONEERING SELF-SOVEREIGN DIGITAL IDENTITY & E-SIGNATURE PLATFORM",
      sub: "End-to-end solutions for e-Government, eKYC, eID, digital finance, education, and digital services.",
      trynow: "Sign up now",
      explore: "Explore solutions",
    },
  },
  footer: {
    explore: {
      title:
        "Discover Quantera — an enterprise-grade Blockchain platform that meets international standards, seamlessly integrating self-sovereign digital identity, electronic certificates, high-trust digital signatures, and a digital identity wallet into a comprehensive solution.",
    },
    contact: {
      contact: "Contact",
      address:
        "9th Floor, Thuy Loi 4 Office Building, 286–288 Nguyen Xi Street, Binh Loi Trung Ward, Ho Chi Minh City",
    },
    about: {
      aboutquantera: "About Quantera",
      about: "Introduce",
      solutions: "Solutions",
      applications: "Applications",
      partners: "Partners",
      blogs: "Blog",
      contact: "Contact",
      ecosystem: "Ecosystem",
    },
    certificate: {
      certificate: "Certifications",
    },
    links: {
      privacy: "Privacy Policy",
      terms: "Terms of Use",
    },
  },

  about: {
    caption: "INTRODUCTION",
    headline1: "One platform – All trusted connections between",
    headline2: " Government and Enterprises",
    sub: "Quantera is a platform that connects governments and enterprises through advanced Blockchain technology — secure, autonomous, and internationally compliant. It ensures safe, transparent, and fraud-resistant digital identity authentication in cyberspace while protecting users' privacy.",

    cards: {
      mission: {
        mission: "Mission",
        text: "Building a trusted Blockchain platform that helps organizations, businesses and governments:",
        li1: "Self-sovereign digital identity management (SSI).",
        li2: "Deploy qualified electronic signatures (QES) with high legal validity.",
        li3: "Issue & verify digital certificates (VC).",
        li4: "Develop a secure digital identity wallet.",
      },

      vision: {
        title: "Vision",
        text: "To become a leading core digital infrastructure platform in Vietnam and Southeast Asia in the field of digital identity and electronic signatures, fully aligned with international standards.",
      },

      values: {
        title: "Core Values",
        li1: "Technology autonomy.",
        li2: "Data security.",
        li3: "Maximum confidentiality.",
        li4: "High scalability.",
        li5: "Compatibility with international standards (EBSI, eIDAS, EUDI Wallet).",
      },
    },
  },

  solutions: {
    caption: "SOLUTIONS",
    headline: "Comprehensive Digital Identity System for the Digital Era",
    sub: "An integrated identity solution combining SSI, VC, QES, and eID Wallet empowers users to control their data, sign securely, store and verify identity according to international standards, ready for digital services and e-Government.",

    cards: {
      ssi: {
        title: "Self-Sovereign Identity (SSI)",
        items: [
          "Digital identity management that lets users control their own personal data.",
          "Integration with Decentralized Identifiers (DID) & ZKP.",
          "Issue, store, and verify identities securely.",
        ],
      },
      vc: {
        title: "Verifiable Credentials (VC)",
        items: [
          "Solution for issuing and verifying electronic credentials.",
          "Supports credentials: eID, eKYC, licenses, diplomas.",
          "Compliant with EBSI, W3C VC standards.",
        ],
      },
      qes: {
        title: "Qualified Electronic Signature (QES)",
        items: [
          "Highest legal-value digital signature.",
          "Supports multiple Vietnamese & international CAs.",
          "Compliant with eIDAS (EU) and Vietnam signature standards.",
        ],
      },
      wallet: {
        title: "Digital Wallet & eID Wallet",
        items: [
          "Multi-purpose wallet storing private keys, DID, VC.",
          "Supports the EUDI Wallet standard.",
          "Secure, convenient, ready for e-Gov integration.",
        ],
      },
    },
  },

  app: {
    caption: "SOLUTIONS",
    headline: "Quantera’s Core Technologies",
    sub: "The digital identity platform leverages Hyperledger Fabric Blockchain, integrating SSI, Qualified Electronic Signatures (QES), secure digital wallets, and cross-border interoperability. It supports international standards (EBSI, EUDI Wallet, DIDComm), ensuring self-sovereign identity, personal data protection, and compatibility with global digital identity infrastructures.",

    features: {
      blockchain: {
        title: "Blockchain Core: Hyperledger Fabric",
        desc: [
          "An advanced permissioned Blockchain network, specialized for businesses and governments.",
          "Highly scalable, decentralized, secure, and reliable.",
        ],
        titlesub: "TRUST",
        titlesub1: "& SECURITY",
      },
      ssi: {
        title: "Self-Sovereign Identity (SSI)",
        desc: [
          "Technologies: DID, VC, ZKP, JWT, JSON-LD.",
          "Empowers users with self-sovereign identity and personal data protection.",
        ],
        titlesub: "SELF-SOVEREIGN",
        titlesub1: "IDENTITY",
      },
      qes: {
        title: "Qualified Electronic Signature (QES)",
        desc: [
          "Integrated with international and Vietnamese CAs.",
          "Supports multiple signing methods: Remote Signing, Local Signing.",
        ],
        titlesub: "LEGAL",
        titlesub1: "VALIDITY",
      },
      wallet: {
        title: "Digital Wallet",
        desc: [
          "Manage DID, VC, and QES in a single application.",
          "Compatible with EUDI Wallet standards, ensuring ultimate data protection.",
        ],
        titlesub: "SECURE",
        titlesub1: "WALLET",
      },
      intero: {
        title: "Interoperability",
        desc: [
          "Compatible with EBSI, EUDI Wallet, DIDComm.",
          "Ready for cross-border connections with global eID ecosystems.",
        ],
        titlesub: "GLOBAL",
        titlesub1: "CONNECTIVITY",
      },
    },
  },

  partners: {
    caption: "PARTNERS",
    headline: "Trusted Partners",
    items: {
      goverment: {
        title: "Government & Public Authorities",
        description:
          "Coordinate and manage population data, diplomas, and public services.",
      },
      bank: {
        title: "Banks & Financial Institutions",
        description:
          "Pioneering Blockchain applications in money transfer, L/C, and loyalty.",
      },
      enterprise: {
        title: "Digital Service Enterprises",
        description:
          "Directly connecting with users, integrating Blockchain into payments, invoices, eKYC, and loyalty.",
      },
      blockchain: {
        title: "Blockchain & e-Signature Providers",
        description:
          "Potential to combine Blockchain to upgrade towards decentralized identity and e-signatures.",
      },
    },
  },

  ecosystem: {
    caption: "ECOSYSTEM",
    headline: "Quantera ecosystem",
    gopaperlessagent: "Secure, flexible, and optimized operations with SAP 2FA and centralized key management.",
    gopaperless: "Work smarter, securely, and easily sign legally binding documents in Vietnam.",
    trustedbilling: "Automate payments, electronic invoicing, and real-time reconciliation."

  },

  applications: {
    caption: "APPLICATIONS",
    headline:
      "Quantera – Interoperable & Secure Digital Identity Infrastructure",
    sub: "The application supports digital identification, eKYC, digital signature and electronic record storage, serving many fields such as e-government, banking, finance, telecommunications, helping to verify security, reduce fraud and expand digital services.",
    slides: {
      egov: {
        title: "e-Government",
        bullets: [
          "Issue eIDs, digital citizen documents, and manage electronic records.",
          "Provide digital signatures for files and forms on public service platforms.",
        ],
      },
      ekyc: {
        title: "eKYC & Digital Identity",
        bullets: [
          "Identity verification for finance, banking, and telecommunications.",
          "Reduce fraud and risks during onboarding processes.",
        ],
      },
      docsign: {
        title: "Legal Transaction Signing",
        bullets: [
          "Secure and legally valid electronic contracts and documents.",
        ],
      },
      bank: {
        title: "Banking & Digital Finance",
        bullets: [
          "eKYC, e-wallets, and digital identity–based payment services.",
          "Securely and compliantly expand digital financial services.",
        ],
      },
    },
  },

  contact: {
    caption: "CONTACT",
    title: {
      line1: "Need consultation or",
      line2: "a solution demo?",
    },
    subtitle: {
      prefix: "Get in touch with",
      brand: "QUANTERA",
    },
    form: {
      title: "Contact Us",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email",
      company: "Company",
      message: "Message",
      submit: "Submit",
      sending: "Sending...",
      required: "Required",
      invalidEmail: "Invalid email address",
      invalidPhone: "Invalid Phone number",
      success: "Message sent successfully!",
      error: "An error occurred, please try again.",
    },
  },

  chat: {
    title: "Quantera Assistant",
    subtitle: "Ask about solutions & ecosystem",
    welcome: "Hello! I can help you learn about Quantera, GoPaperless Agent/Portal, and Trusted Billing.",
    placeholder: "Type your question...",
    send: "Send",
    open: "Open chat",
    close: "Close chat",
    thinking: "Thinking...",
    contact: "Contact us",
    call: "Call 1900 6884",
    zalo: "Chat on Zalo",
    learnMore: "Learn more",
    error: "Unable to reach the chatbot. Please use the Contact form or call 1900 6884.",
    quickReplies: {
      q1: "What is Quantera?",
      q2: "Agent vs Portal?",
      q3: "What is Trusted Billing?",
    },
  },

  cookies: {
    title: "This website uses cookies",
    description: "By clicking 'Accept all', you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.",
    preferences: "Cookie preferences",
    rejectAll: "Reject all",
    acceptAll: "Accept all",

    preferencesTitle: "Custom Cookie Preferences",
    strictlyNecessary: "Strictly Necessary",
    strictlyNecessaryDesc: "These cookies are required for the website to function properly. They do not collect data for advertising purposes and cannot be disabled, as this would break the site's basic functionality.",
    alwaysActive: "Always Active",

    functional: "Functional / Preferences",
    functionalDesc: "These cookies remember your choices and settings to provide a more personalized experience, such as your selected language, dark/light theme, font size, region, or other customizations.",

    analytics: "Analytics / Performance",
    analyticsDesc: "These cookies help us understand how visitors interact with the site. All data is fully anonymized and used solely to improve site performance, loading speed, and content quality—no personal identification.",

    marketing: "Marketing / Advertising",
    marketingDesc: "These cookies enable us to show you more relevant ads on our site and across other platforms. They anonymously track your browsing behavior and prevent the same ad from appearing repeatedly.",

    savePreferences: "Save preferences",
    cancel: "Cancel"
  }
};

export default vi;
